<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          状态
        </div>
        <el-select
          v-model="searchForm.valid"
          placeholder="请选择状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in identityValidList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>

        <div class="label">
          代理商
        </div>
        <el-select
          v-model="searchForm.agentId"
          placeholder="请选择状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in agentList"
            :key="item.id"
            :label="item.agentName"
            :value="item.id"
          />
        </el-select>
        <div class="label">
          代理商用户
        </div>
        <el-select
          v-model="searchForm.agentUserId"
          placeholder="请选择状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in agentUserList"
            :key="item.userId"
            :label="item.showName"
            :value="item.userId"
          />
        </el-select>
        <div class="label">
          省市区
        </div>
        <el-cascader
          v-model="cascaderInfo"
          :props="cascaderProps"
          :options="province"
          @change="formatCity"
        />
      </div>
      <div class="r">
        <el-input
          v-model="searchForm.agencyName"
          placeholder="请输入机构名称"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
        <el-button
          type="primary"
          @click="goCreatOrEdit"
        >
          新建机构
        </el-button>
      </div>
    </div>
    <div class="header">
      <div class="l">
        <div class="label">
          开始时间
        </div>
        <el-date-picker
          v-model="searchForm.createStart"
          type="date"
          placeholder="选择开始时间"
          value-format="timestamp"
          @change="getList()"
        />
        <div class="label">
          结束时间
        </div>
        <el-date-picker
          v-model="searchForm.createEnd"
          type="date"
          placeholder="选择结束时间"
          value-format="timestamp"
          @change="getList()"
        />
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @sortChange="sortChange"
      @buttonClick="buttonClick"
    />
    <agency-agent-dialog
      :dialog-visible.sync="dialogVisible"
      :item="agencyAgentItem"
      :agent-list="agentList"
      @confirm="getList"
      @close="()=> agencyAgentItem = {}"
    />
    <!-- 机构转代理商 -->
    <agent-dialog
      :dialog-visible.sync="agencyConvertAgentDialogVisible"
      :item="null"
      :convert-id="agencyConvertAgentId"
      @confirm="getList()"
      @close="()=> agencyConvertAgentId = null"
    />
    <!-- 机构转代理商 -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import agencyAgentDialog from '@/components/common/agencyAgentDialog.vue';
import types, { identityValidList } from '@/config';
import agentDialog from '../agent/dialog/agentDialog.vue';

export default {
  name: 'Home',
  components: {
    dataTable,
    agencyAgentDialog,
    agentDialog,
  },
  data() {
    return {
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'sonList',
      },
      dialogVisible: false,
      agencyConvertAgentDialogVisible: false,
      agencyConvertAgentId: null,
      agencyAgentItem: {},
      identityValidList,
      agentList: [],
      searchForm: {
        valid: '',
        agencyName: '',
        agentId: '',
        agentUserId: '',
        pageNum: 1,
        pageSize: 10,
        sortType: null,
        createEnd: null,
        createStart: null,
      },
      tabelData: {},
      cascaderInfo: '', // 省市区
      tableColumn: [
        {
          key: 'agencyName',
          label: '机构名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'chargePersonName',
          label: '负责人',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'chargePersonPhone',
          label: '负责人电话',
          width: '100px',
          dataType: 'text',
        },
        {
          key: 'agentName',
          label: '代理商名称',
          width: '100px',
          dataType: 'text',
        },
        {
          key: 'agentUserName',
          label: '代理商推广员',
          width: '100px',
          dataType: 'text',
        },
        {
          key: 'provinceCityAreaName',
          label: '省市区',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agencyAddress',
          label: '机构地址',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseRegistrationCount',
          label: '累计报名数',
          width: '80px',
          dataType: 'text',
          default: '0',
          sortable: 'custom',
        },
        {
          key: 'valid',
          label: '状态',
          width: '60px',
          dataType: 'component',
          renderProps: { [types.INDENTITY_VALID_ENABLE]: '启用', [types.INDENTITY_VALID_DISABLE]: '禁用', successKey: types.INDENTITY_VALID_ENABLE },
          render: () => 'status',
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
          sortable: 'custom',
        },
        {
          key: 'control',
          label: '操作',
          width: '320px',
          dataType: 'component',
          renderProps: [
            {
              text: '启用', renderKey: types.INDENTITY_VALID_DISABLE, renderProp: 'valid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '禁用', renderKey: types.INDENTITY_VALID_ENABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 1, disableKey: null,
            },
            {
              text: '查看', renderKey: null, type: 'info', eventIndex: 2, disableKey: null,
            },
            {
              text: '代理商', renderKey: null, type: 'danger', eventIndex: 3, disableKey: null,
            },
            {
              text: '一键转代理', renderKey: null, type: 'success', eventIndex: 4, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['province']),
    agentUserList() {
      if (this.searchForm.agentId) {
        if (this.agentList.filter((v) => v.id === this.searchForm.agentId).length > 0) {
          return this.agentList.filter((v) => v.id === this.searchForm.agentId)[0].userList;
        }
      }
      return [];
    },
  },
  created() {
    this.getList();
    this.getAgentList();
  },
  mounted() {
    if (this.$route.query.agentId) {
      this.searchForm.agentId = Number(this.$route.query.agentId);
    }
    if (this.$route.query.agentUserId) {
      this.searchForm.agentUserId = Number(this.$route.query.agentUserId);
    }
    if (this.$route.query.startTime) {
      this.searchForm.createStart = this.$route.query.startTime;
    }
    if (this.$route.query.endTime) {
      this.searchForm.createEnd = this.$route.query.endTime;
    }
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.agency.getList(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 禁用/启用 机构
    confirmDialog(item) {
      this.$confirm('确定禁用/启用该机构？', '禁用/启用机构', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async () => {
        const { id, valid } = item;
        const data = await axClient.agency.updateAgencyValid(
          {
            id,
            valid: valid === types.INDENTITY_VALID_ENABLE
              ? types.INDENTITY_VALID_DISABLE : types.INDENTITY_VALID_ENABLE,
          },
        );
        if (data) {
          this.$message.success('启用/禁用成功');
          this.getList();
        }
      });
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'AgencyDetails', params: { id: item.id } });
    },
    // 跳转到新增/编辑
    goCreatOrEdit(item) {
      this.$router.push({ name: 'AgencyCreate', params: { id: item.id } });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        case 1:
          this.goCreatOrEdit(item);
          break;
        case 2:
          this.goDetails(item);
          break;
        case 3:
          this.agencyAgentItem = item;
          this.dialogVisible = true;
          break;
        case 4:
          this.agencyConvertAgentDialog(item);
          break;
        default:
          break;
      }
    },
    // 打开新增代理商
    async agencyConvertAgentDialog(item) {
      this.agencyConvertAgentId = item.id;
      console.log(this.agencyConvertAgentId);
      this.agencyConvertAgentDialogVisible = true;
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        courseRegistrationCount: {
          ascending: 10,
          descending: 20,
        },
        createTime: {
          ascending: 30,
          descending: 40,
        },
      };
      this.searchForm.sortType = sortType[prop][order];
      this.getList();
    },
    // 处理省市区
    formatCity(item) {
      const [provinceId, cityId, areaId] = item;
      this.searchForm = Object.assign(this.searchForm, { provinceId, cityId, areaId });
      this.getList();
    },
    // 获取列表
    async getAgentList() {
      this.agentList = await axClient.agent.agentListAllName();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
